import Api from '@/services/Api'

export default {
  getCompanyJobs () {
    return Api().get("/company-jobs");
  },
  updateCompanyJob (params) {
    return Api().put("/company-jobs",params);
  },
  addCompanyJob (params) {
    return Api().post("/company-jobs",params);
  },
  getCompanyJob (params) {
    return Api().get("/company-jobs/"+params);
  },
  deleteCompanyJob(params) {
    return Api().delete("/company-jobs/"+params);
  },
  getCompanyJobsByCompany (params) {
    return Api().get("/company-jobs-by-company/"+params);
  },
  deleteCompanyJobByCompany(params) {
    return Api().delete("/company-jobs-by-company/"+params);
  },

}



// WEBPACK FOOTER //
// ./src/services/CompanyJobService.js